import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import DataTableBodyRow from "./DataTableBodyRow";
import { columnPropType, rowIdPropType, rowPropType } from "./propTypes";
export default class DataTableBody extends PureComponent {
  static propTypes = {
    columns: PropTypes.arrayOf(columnPropType).isRequired,
    rows: PropTypes.arrayOf(rowPropType).isRequired,
    selectedRowIds: PropTypes.arrayOf(rowIdPropType),
    rowProps: PropTypes.object,
    onRowClick: PropTypes.func,
    onRowSelectionChange: PropTypes.func,
  };
  static defaultProps = {
    selectedRowIds: [],
  };
  renderRow = (row, index) => {
    const { columns, selectedRowIds, rowProps, onRowClick, onRowSelectionChange } = this.props;
    const selected = selectedRowIds.indexOf(row.id) >= 0;
    return (
      <DataTableBodyRow
        {...rowProps}
        key={index}
        columns={columns}
        row={row}
        selected={selected}
        onClick={onRowClick}
        onSelectionChange={onRowSelectionChange}
      />
    );
  };

  render() {
    const { columns, rows, selectedRowIds, rowProps, onRowClick, onRowSelectionChange, ...otherProps } = this.props;
    return <tbody {...otherProps}>{rows.map((item, index) => this.renderRow(item, index))}</tbody>;
  }
}
